import decode from "jwt-decode";
import Router from "next/router";

export const loggedIn = () => {
  // Checks if there is a saved token and if it's still valid
  const token = getToken();
  return !!token && !isTokenExpired(token); // handwaiving here
};

export const setToken = (token, expires_at, userType) => {
  // Saves user token to sessionStorage
  localStorage.setItem(`${userType}Token`, token);
  localStorage.setItem(`${userType}ExpiresAt`, expires_at);
};

export const getToken = (redirect: boolean = true) => {
  // Retrieves the user token from localStorage
  if (typeof window !== "undefined") {
    const queryParams = Router && Router.router && Router.router.query;

    if (queryParams.impersonateAvatar || queryParams.impersonateName) {
      localStorage.setItem(
        "impersonated",
        (queryParams.impersonateAvatar || queryParams.impersonateName) as string
      );
      sessionStorage.setItem("adminToken", queryParams.auth as string);
      if (redirect) {
        Router.push("/dashboard").then();
      }
    } else if (queryParams.auth) {
      localStorage.removeItem("impersonated");
      setToken(queryParams.auth, queryParams.expires_at, "admin");
      if (redirect) {
        Router.push("/dashboard").then();
      }
    }

    return sessionStorage.getItem("adminToken") || localStorage.getItem("adminToken");
  }
};

export const logout = () => {
  // Clear user token from sessionStorage
  // If an admin token exists, wipe any other student tokens as well that might have been created while impersonating
  sessionStorage.removeItem("adminToken");
  if (localStorage.getItem("adminToken")) {
    localStorage.removeItem("adminToken");
    localStorage.removeItem("adminExpiresAt");
    localStorage.removeItem("studentToken");
    localStorage.removeItem("impersonated");
    localStorage.removeItem("studentExpiresAt");
  } else {
    // Otherwise just wipe all student tokens
    localStorage.removeItem("studentToken");
    localStorage.removeItem("studentExpiresAt");
  }

  Router.push(`${window.location.origin}/login`);
  return;
};

export const isTokenExpired = (token: string) => {
  try {
    const decoded = decode<Token>(token);
    return decoded.exp < Date.now() / 1000;
  } catch (err) {
    return false;
  }
};
